import { render } from "./submenu.vue?vue&type=template&id=7bfd4fe8&scoped=true"
import script from "./submenu.vue?vue&type=script&lang=js"
export * from "./submenu.vue?vue&type=script&lang=js"

import "./submenu.vue?vue&type=style&index=0&id=7bfd4fe8&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfd4fe8"]])

export default __exports__